module.exports = "<div class=\"slider-wrapper\" [ngClass]=\"[id]\">\r\n  <div class=\"percentage-line\"></div>\r\n  <div [hidden]=\"currentValueHidden\" class=\"current-value\"></div>\r\n  <div class=\"arrow-pointer\" [ngClass]=\"{'hide': displayArrow == 'NotLive'}\"></div>\r\n  <div id=\"{{id}}\"></div>\r\n  <div class=\"status\"><span class=\"direction\"></span>{{label}}</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/NightKey/CMS/nightkey-cms/src/app/shared/slider/slider.component.html
// module id = ../../../../../src/app/shared/slider/slider.component.html
// module chunks = main